import  { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useOpenCloseAuthModalStore } from "../../stores/Auth/useAuthModal";

const ResetPasswordHandler = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { open } = useOpenCloseAuthModalStore();

  useEffect(() => {
    // Kiểm tra xem có key và login trong URL không
    const key = searchParams.get("key");
    const login = searchParams.get("login");

    if (key && login) {
      // Lưu thông tin reset password vào localStorage hoặc sessionStorage
      sessionStorage.setItem("resetPasswordKey", key);
      sessionStorage.setItem("resetPasswordLogin", login);

      // Mở modal với mode reset password
      open("reset-password");

      // Chuyển về trang home
      navigate("/", { replace: true });
    }
  }, [searchParams, navigate, open]);

  return null; // Component này không render gì
};

export default ResetPasswordHandler;
